// extracted by mini-css-extract-plugin
export default {"root":"BlockContainer_root__9JaaU"};